import { render, staticRenderFns } from "./stationClamp_combinedV2.vue?vue&type=template&id=2558e5b7&scoped=true"
import script from "./stationClamp_combinedV2.vue?vue&type=script&lang=js"
export * from "./stationClamp_combinedV2.vue?vue&type=script&lang=js"
import style0 from "./stationClamp_combinedV2.vue?vue&type=style&index=0&id=2558e5b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2558e5b7",
  null
  
)

export default component.exports